import { render, staticRenderFns } from "./EnvironmentEdit.vue?vue&type=template&id=22671301&scoped=true&"
import script from "./EnvironmentEdit.vue?vue&type=script&lang=ts&"
export * from "./EnvironmentEdit.vue?vue&type=script&lang=ts&"
import style0 from "./EnvironmentEdit.vue?vue&type=style&index=0&id=22671301&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22671301",
  null
  
)

export default component.exports